export const registerTabPanel = function expandList() {
    const tabPanelLists = document.querySelectorAll('.tab-panel-list')
    const tabsContainers = document.querySelectorAll('.tab-container')

    tabPanelSwitch(tabPanelLists, tabsContainers)

    function tabPanelSwitch(tabPanelLists, tabsContainers) {
        tabPanelLists.forEach((tabPanelList) => {
            const tabs = tabPanelList.querySelectorAll('.tab')
            tabs.forEach((item, index) => {
                if (index === 0) item.classList.add('active')
                item.addEventListener('click', () => {
                    tabs.forEach((item, index) => {
                        item.classList.remove('active')
                        tabsContainers[index].classList.remove('active')
                    })
                    item.classList.add('active')
                    tabsContainers[index].classList.add('active')
                })
            })
        })

        if (tabsContainers[0]) tabsContainers[0].classList.add('active')
    }
}
